import * as boundValue from "./bound.js";
import * as discreteValue from "./discrete.js";
import * as rangeValue from "./range.js";
/**
 * @public
 */
export var Value;
(function (Value) {
    Value.Bound = boundValue.Bound;
    Value.Discrete = discreteValue.Discrete;
    Value.Range = rangeValue.Range;
    Value.discrete = Value.Discrete.of, Value.isDiscrete = Value.Discrete.isDiscrete;
    Value.range = Value.Range.of, Value.minimumRange = Value.Range.minimum, Value.maximumRange = Value.Range.maximum, Value.isRange = Value.Range.isRange;
    Value.bound = Value.Bound.of;
})(Value || (Value = {}));
//# sourceMappingURL=value.js.map